/* ------------------------------------------------------------------------------
@name: Components Index
@description: Indexing all components
--------------------------------------------------------------------------------- */

export { default as Header } from '@components/Header';
export { default as Footer } from '@components/Footer';
export { default as HeroBanner } from '@components/HeroBanner';
export { default as HeroBannerMobile } from '@components/HeroBannerMobile';
export { default as ExperienceDetail } from '@components/ExperienceDetail/ExperienceDetailSection';
export { default as ModalDetail } from '@components/ModalDetail';
export { default as Projects } from '@components/Projects/ProjectsSection';
export { default as ContentTransition } from '@components/_Elements/ContentTransition';
